import { render, staticRenderFns } from "./UserOmsDetail.vue?vue&type=template&id=6a05c816&scoped=true&"
import script from "./UserOmsDetail.vue?vue&type=script&lang=js&"
export * from "./UserOmsDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a05c816",
  null
  
)

export default component.exports